/**
 * The kinds of a risk register update, for the picker on Status & updates
 * and the badge on the timeline. Same list as
 * server/services/risk/updateKinds.js (the test pins the two together).
 */
export const UPDATE_KINDS = [
  ['quarterly_update', 'Quarterly risk assessment update'],
  ['email_sent', 'Email sent'],
  ['email_received', 'Email received'],
  ['meeting', 'Meeting'],
  ['call', 'Phone call'],
  ['workstream_reply', 'Workstream reply'],
  ['committee', 'Compliance Committee review'],
  ['mitigation_progress', 'Mitigation progress'],
  ['document', 'Document received'],
  ['note', 'Note'],
];
const LABELS = Object.fromEntries(UPDATE_KINDS);
export const KIND_CLS = {
  quarterly_update: 'bg-orange-50 text-orange-700',
  email_sent: 'bg-blue-50 text-blue-700',
  email_received: 'bg-blue-50 text-blue-600',
  meeting: 'bg-violet-50 text-violet-700',
  call: 'bg-violet-50 text-violet-600',
  workstream_reply: 'bg-indigo-50 text-indigo-600',
  committee: 'bg-emerald-50 text-emerald-700',
  mitigation_progress: 'bg-teal-50 text-teal-700',
  document: 'bg-slate-100 text-slate-600',
  note: '',
};
export function updateKindLabel(k) { return LABELS[String(k || '')] || LABELS.note; }
/** The kind to show: the entry's own, or the one an older entry's note implies. */
export function kindOf(u) {
  if (u?.update_kind && LABELS[u.update_kind]) return u.update_kind;
  const s = String(u?.note || '');
  if (/\[Email reply\]/.test(s)) return 'email_received';
  if (/\[Workstream\]/.test(s)) return 'workstream_reply';
  return 'note';
}
